import { render, staticRenderFns } from "./BaseLayoutNewMenu.vue?vue&type=template&id=ddcc74fe"
import script from "./BaseLayoutNewMenu.vue?vue&type=script&lang=js"
export * from "./BaseLayoutNewMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutNewMenu.vue?vue&type=style&index=0&id=ddcc74fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports